import React from 'react';
import styled from 'styled-components';
import HarmonicaItem from './HarmonicaItem';
import { isHiddenQuestion, answerFor } from '../utils/faqOverrides';

const HarmonicaContainer = styled.div`
  width: 100%;
  margin-top: ${(props) => (props.sequence ? props.theme.constants.defaultContent : '0')};
`;

const Harmonica = ({ items, sequence }) => (
  <HarmonicaContainer sequence={sequence}>
    {items && items
      .filter((item) => !isHiddenQuestion(item.fields.vraag))
      .map((item) => (
        <HarmonicaItem
          key={item.sys.id + Math.random()}
          title={item.fields.vraag}
          text={answerFor(item.fields.vraag, item.fields.antwoord)}
        />
      ))}
  </HarmonicaContainer>
);

export default Harmonica;
